import enLang from './entries/en_US';
import koLang from './entries/ko_KR';

const AppLocale = {
  en: enLang,
  ko: koLang,
};

export default AppLocale;
